module.exports = __webpack_public_path__ + "img/jesusc.b5ad1144.png";